import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';
import { apiKey } from '../../utils/ktcUtils';

const ElectionResults = () => {
  const [results, setResults] = useState({});
  const [timer, setTimer] = useState(30);
  const token = getToken();
  // Fetch results from API
  const fetchResults = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/election-results`;
      const response = await axios.get(url, {
        headers: { 'x-api-key': apiKey },
      });
     // console.log('url:', url, 'response:', response);
      const grouped = groupByTitle(response.data.report); // Flat array → grouped object
      setResults(grouped);
    } catch (error) {
      console.error('Error fetching results:', error);
    }
  };
  // Load results initially and every 30 seconds
  useEffect(() => {
    fetchResults();
    const interval = setInterval(() => {
      fetchResults();
      setTimer(30);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // Countdown timer
  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const groupByTitle = (data) => {
    const grouped = {};
    data.forEach((item) => {
      if (!grouped[item.title]) {
        grouped[item.title] = [];
      }
      grouped[item.title].push(item);
    });
    return grouped;
  };
  return (
    <div className=" mt-4" style={{ width: '95%', margin: 'auto' }}>
      <div className="alert alert-info text-center fs-5 fw-bold">
        Reloading in {timer} second{timer !== 1 ? 's' : ''}
      </div>

      <div className="">
        <div className="row">
          {Object.entries(results).map(([title, candidates], index) => {
            return (
              <div key={title} className="row">
                <div className="col-12">
                  <h2 className=" text-center">
                    <strong>{title}</strong>
                  </h2>
                </div>
                {candidates.map((candidate) => {
                  let colorClass = 'bg-secondary';
                  const percent = candidate.percentage;

                  if (percent <= 25) colorClass = 'bg-danger';
                  else if (percent <= 50) colorClass = 'bg-warning';
                  else if (percent <= 75) colorClass = 'bg-info';
                  else colorClass = 'bg-success';

                  return (
                    <div key={candidate.id} className="col-md-2 mb-4">
                      <div className="card shadow-sm h-100">
                        <center>
                          <img
                            src={`${API_URL}/${candidate.image}`}
                            className="card-img-top"
                            alt={candidate.name}
                            style={{ height: '200px', width: '200px' }}
                          />
                        </center>
                        <div className="card-body text-center">
                          <h5 className="card-title">{candidate.name}</h5>
                          <div className="mt-3">
                            <div>
                              <strong>Total Votes:</strong>{' '}
                              {candidate.all_votes} /{' '}
                              {candidate.candidate_votes} = {percent}%
                            </div>
                          </div>
                        </div>
                        <div className="card-footer text-center">
                          <div className="progress" style={{ height: '25px' }}>
                            <div
                              className={`progress-bar ${colorClass}`}
                              role="progressbar"
                              style={{
                                width: `${percent}%`,
                                fontWeight: 'bold',
                                fontSize: '1rem',
                              }}
                            >
                              {percent}%
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ElectionResults;
